module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photofeed"
  }, [_c('div', {
    staticClass: "photo-list"
  }, [_vm._l((_vm.photosReversed), function(photo) {
    return (_vm.photos.length > 0) ? _c('div', {
      staticClass: "list list-photo"
    }, [_c('div', {
      staticClass: "thumb eye",
      style: ({
        backgroundImage: 'url(' + photo.thumburl + ')'
      }),
      on: {
        "click": function($event) {
          _vm.$store.dispatch('viewSinglePhoto', photo)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [(_vm.showSpot === 'true') ? _c('div', {}, [_c('div', {
      staticClass: "blue-circle"
    }), _vm._v(" "), _c('div', {
      staticClass: "spot-link",
      on: {
        "click": function($event) {
          _vm.popSpot(photo.spot)
        }
      }
    }, [_vm._v(" " + _vm._s(photo.spot))]), _vm._v(" | "), (photo.score) ? _c('span', [_vm._v(_vm._s(photo.score) + "/100 poäng | " + _vm._s(photo.voteCount) + " röster")]) : _c('span', [_vm._v("färre än 5 röster")])]) : _vm._e(), _vm._v(" "), (_vm.showUser === 'true') ? _c('div', {
      staticClass: "username"
    }, [_c('div', {
      staticClass: "blue-circle"
    }), _vm._v(" "), _c('div', {
      staticClass: "spot-link"
    }, [_vm._v(" " + _vm._s(photo.spot))]), _vm._v(" av "), _c('b', [_vm._v(_vm._s(photo.username))]), _vm._v(" "), (true === false) ? _c('div', {
      staticStyle: {
        "padding": "3px 15px",
        "background-color": "orange",
        "color": "#fff",
        "border-radius": "4px",
        "margin-left": "10px",
        "cursor": "pointer",
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.makeSpotWinner(photo)
        }
      }
    }, [_vm._v("GÖR TILL VINNARE!!")]) : _vm._e()]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.photos.length == 0) ? _c('div', {
    staticClass: "empty list"
  }, [_vm._t("empty", [_vm._v("Inga foton.")])], 2) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28b1f330"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/photoFeed.vue
// module id = 109
// module chunks = 0